import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/pay-item-compensates', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/pay-item-compensates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/pay-item-compensates/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/pay-item-compensates/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/pay-item-compensates/${id}`).then(response => Promise.resolve(response.data))
}

export const customRule = (options = {}) => {
  return httpClient
    .get('/api/pay-item-compensates/custom-rules', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, find, update, destroy, customRule }
